import { motion } from "framer-motion";
import { Check, Gem, MessageCircle, Sparkles } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Reveal, SectionHead } from "./Reveal";
import { TrFlag, EuFlag } from "./Flags";

const Pkg = ({ p, i }) => {
  const featured = p.featured;
  const test = p.trial;
  return (
    <Reveal delay={i * 0.12} className="h-full">
      <motion.div whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 240, damping: 20 }}
        data-testid={`package-card-${p.id}`}
        className={`relative h-full flex flex-col rounded-[32px] p-8 md:p-10 border overflow-hidden ${featured ? "bg-[#5b5fd6] border-[#8a8dff]" : "bg-[#13114f] border-white/10"}`}>
        {featured && <div className="absolute -right-20 -top-20 h-56 w-56 rounded-full moon opacity-40" />}
        <div className="relative flex items-center justify-between">
          <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${featured ? "bg-white text-[#0d0b3d]" : "bg-white/10 text-[#c9c6f0]"}`}>
            {test ? <Sparkles size={13} /> : <Gem size={13} />} {p.tag}
          </span>
          <span className="flex items-center gap-3">
            <span className={`text-sm ${featured ? "text-white" : "text-[#c9c6f0]"}`}>{p.period}</span>
            {p.flag === "tr" && <TrFlag className="h-7 w-auto rounded shadow-lg" />}
            {p.flag === "eu" && <EuFlag className="h-7 w-auto rounded shadow-lg" />}
          </span>
        </div>
        <h3 className="relative font-display text-2xl md:text-[1.7rem] font-extrabold uppercase mt-8 leading-tight flex items-start gap-3" data-testid={`package-name-${p.id}`}>
          {!test && <Gem size={28} className={`shrink-0 mt-0.5 ${featured ? "text-white" : "text-[#8a8dff]"}`} />}
          <span>{p.name}</span>
        </h3>
        <p className={`relative mt-2 text-sm ${featured ? "text-white/90" : "text-[#c9c6f0]"}`}>{p.coverage}</p>
        <div className="relative mt-8 flex items-end gap-2" data-testid={`package-price-${p.id}`}>
          <span className="font-display text-5xl md:text-6xl font-extrabold tracking-tight">{p.price}</span>
          {p.unit && <span className="font-display text-2xl font-semibold pb-2">{p.unit}</span>}
        </div>
        <ul className="relative mt-8 space-y-3 flex-1">
          {p.features.map((f) => (
            <li key={`${p.id}-${f}`} className="flex items-start gap-3 text-sm md:text-base">
              <Check size={18} className={`mt-0.5 shrink-0 ${featured ? "text-white" : "text-[#8a8dff]"}`} /> {f}
            </li>
          ))}
        </ul>
        <a href={p.link} target="_blank" rel="noreferrer" data-testid={`package-order-${p.id}`}
          className={`relative mt-10 inline-flex items-center justify-center gap-2 rounded-full px-6 py-4 font-semibold transition-colors ${featured ? "bg-white text-[#0d0b3d] hover:bg-[#0d0b3d] hover:text-white" : "bg-[#5b5fd6] text-white hover:bg-white hover:text-[#0d0b3d]"}`}>
          <MessageCircle size={18} /> {p.cta}
        </a>
      </motion.div>
    </Reveal>
  );
};

export default function Packages() {
  const { packages } = useSite();
  return (
    <section id="paketler" className="relative bg-[#0d0b3d] py-24 md:py-36 overflow-hidden" data-testid="packages-section">
      <div className="absolute left-1/2 top-0 -translate-x-1/2 h-px w-2/3 bg-gradient-to-r from-transparent via-[#8a8dff] to-transparent" />
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead kicker="02 · Elmas Paketler" title={<>Paketini seç,<br />WhatsApp'tan yaz.</>} testid="packages-title"
          sub="12 aylık Elmas paketler ya da önce 6 saatlik ücretsiz test. Sipariş için butona dokunman yeterli." />
        <div className={`grid grid-cols-1 md:grid-cols-2 ${packages.length >= 3 ? "lg:grid-cols-3" : ""} gap-5 items-stretch`}>
          {packages.map((p, i) => <Pkg key={p.id} p={p} i={i} />)}
        </div>
      </div>
    </section>
  );
}
